"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerseTree = void 0;
const ScriptureTreeObject_1 = require("./ScriptureTreeObject");
class VerseTree extends ScriptureTreeObject_1.ScriptureTreeObject {
    get chapter() {
        return this.parent;
    }
    get book() {
        return this.parent.parent;
    }
    get translation() {
        return this.parent.parent.parent;
    }
    get fromVid() {
        return this.data.fromVid;
    }
    get toVid() {
        return this.data.toVid;
    }
    get label() {
        return this.data.label;
    }
    get text() {
        return this.data.text;
    }
    get parts() {
        return this.data.parts;
    }
    dump() {
        return {
            tid: this.translation.tid,
            bid: this.book.bid,
            chapter: this.chapter.number,
            fromVid: this.fromVid,
            toVid: this.toVid,
            label: this.label,
            text: this.text,
            parts: this.parts,
            bookName: this.book.name,
            translationName: this.translation.name,
            translationAbbr: this.translation.abbreviation,
        };
    }
    /**
     * Get the labels of all partial verses in this verse.
     */
    get partLabels() {
        return this.data.parts.map((part) => part.label);
    }
    /**
     * Get a specific partial verse by label.
     */
    getPart(label) {
        return this.data.parts.find((part) => part.label === label) || null;
    }
}
exports.VerseTree = VerseTree;
